module.exports = __webpack_public_path__ + "media/images/admin/icons/clipboard-a7baf41069746e4c53c600eeb023c62c.svg";